import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinnavimumbai() {



    const cardData = {





keyword: "Ertiga On Rent in Navi Mumbai",

headingDescription: "Shreesha Tours & Travels offers reliable and comfortable Ertiga On Rent in Navi Mumbai for family trips, airport transfers, corporate travel, business meetings, wedding transportation, sightseeing tours, one-way journeys, round trips, and outstation travel. Our chauffeur-driven Maruti Ertiga provides spacious seating, comfortable interiors, excellent mileage, and smooth performance, making it an ideal choice for families, small groups, and long-distance journeys. With experienced drivers, well-maintained vehicles, transparent pricing, doorstep pickup, flexible rental options, and 24/7 customer support, we ensure a safe and convenient travel experience. Whether you need an Ertiga for local travel or an outstation road trip from Navi Mumbai, Shreesha Tours & Travels provides dependable rental services with complete comfort and reliability.",

topPlaces: [
  {
    title: "Navi Mumbai to Pune",
    description: "Pune is one of the most popular routes from Navi Mumbai for corporate travel, IT professionals, educational visits, and family trips. Travelers can explore Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Dagdusheth Ganpati Temple, Koregaon Park, and Kharadi IT hubs. The spacious seating of Ertiga makes it a perfect option for families and small groups traveling comfortably on the Mumbai Pune Expressway."
  },
  {
    title: "Navi Mumbai to Lonavala",
    description: "Lonavala is a beautiful hill station near Mumbai and Pune, famous for Tiger Point, Bhushi Dam, Pawna Lake, Karla Caves, Rajmachi Fort, and Della Adventure Park. It is a preferred weekend getaway for families, couples, and corporate groups. Ertiga rental provides comfortable seating and enough luggage space for a relaxed hill station journey."
  },
  {
    title: "Navi Mumbai to Shirdi",
    description: "Shirdi is a major pilgrimage destination famous for Sai Baba Samadhi Temple, Dwarkamai, Chavadi, Gurusthan, and Lendi Baug. Devotees from Navi Mumbai frequently travel to Shirdi for darshan and spiritual tours. Booking an Ertiga on rent is convenient for families, senior citizens, and groups looking for a comfortable long-distance cab journey."
  },
  {
    title: "Navi Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station known for Venna Lake, Arthur's Seat, Mapro Garden, strawberry farms, Lingmala Waterfall, and breathtaking viewpoints. Tourists visit this destination for relaxing holidays, honeymoon trips, and family vacations. The spacious Ertiga offers a comfortable ride through the beautiful mountain roads of the Western Ghats."
  },
  {
    title: "Navi Mumbai to Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchavati, Sula Vineyards, Ramkund, Pandavleni Caves, and religious attractions. It is a popular destination for pilgrimage, wine tourism, and business travel. An Ertiga rental from Navi Mumbai provides a comfortable travel option for families and groups visiting Nashik."
  },
  {
    title: "Navi Mumbai to Alibaug",
    description: "Alibaug is a beautiful coastal destination known for beaches, Kolaba Fort, Varsoli Beach, water sports, luxury resorts, and peaceful seaside views. It is one of the most preferred weekend destinations from Navi Mumbai. Ertiga on rent is suitable for friends and families carrying luggage for beach holidays and resort stays."
  },
  {
    title: "Navi Mumbai to Ratnagiri",
    description: "Ratnagiri is a scenic Konkan destination famous for Ganpatipule Temple, Ratnadurg Fort, Aare Ware Beach, Thiba Palace, and Alphonso mango orchards. Travelers enjoy coastal roads, beaches, temples, and natural beauty. Ertiga provides extra comfort for long Konkan routes with spacious seating and smooth highway travel."
  },
  {
    title: "Navi Mumbai to Kolhapur",
    description: "Kolhapur is known for Mahalaxmi Temple, Panhala Fort, Rankala Lake, Jyotiba Temple, and traditional Maharashtrian culture. The city attracts pilgrims, tourists, and business travelers throughout the year. Renting an Ertiga is a convenient choice for group travel with comfortable seating and luggage capacity."
  },
  {
    title: "Navi Mumbai to Goa",
    description: "Goa is a popular holiday destination famous for beaches, forts, churches, water sports, nightlife, and luxury resorts. Many travelers prefer road trips from Navi Mumbai to Goa for a memorable vacation experience. Ertiga rental offers a comfortable option for families and groups traveling on long-distance routes."
  },
  {
    title: "Navi Mumbai to Saputara",
    description: "Saputara is Gujarat's only hill station known for Saputara Lake, Sunset Point, Ropeway, Gira Waterfalls, Artist Village, and beautiful green landscapes. It is an ideal destination for nature lovers and family holidays. An Ertiga cab provides a comfortable journey with ample space for passengers and travel bags."
  }
],


"services": [
  {
    "name": "Ertiga on Rent in Navi Mumbai",
    "description": "Book Ertiga on Rent in Navi Mumbai for comfortable and affordable chauffeur-driven travel. Choose Ertiga rental services for family trips, airport transfers, corporate travel, sightseeing, and outstation journeys with clean AC vehicles and professional drivers."
  },
  {
    "name": "Ertiga Rental Navi Mumbai",
    "description": "Reserve Ertiga Rental Navi Mumbai with experienced chauffeurs, spacious seating, and reliable service for local travel, airport transfers, and long-distance trips."
  },
  {
    "name": "Ertiga Hire in Navi Mumbai",
    "description": "Choose Ertiga Hire in Navi Mumbai for comfortable group travel with premium vehicles, professional drivers, and flexible booking options."
  },
  {
    "name": "Ertiga Car Rental Navi Mumbai",
    "description": "Book Ertiga Car Rental Navi Mumbai for family vacations, business travel, and outstation journeys with spacious interiors and affordable rental packages."
  },
  {
    "name": "Ertiga Taxi Service Navi Mumbai",
    "description": "Reserve Ertiga Taxi Service Navi Mumbai for reliable local and outstation transportation with experienced chauffeurs and well-maintained AC vehicles."
  },
  {
    "name": "Book Ertiga on Rent in Navi Mumbai",
    "description": "Book Ertiga on Rent in Navi Mumbai online with instant confirmation, flexible pickup timings, transparent pricing, and 24x7 customer support."
  },
  {
    "name": "Best Ertiga on Rent Navi Mumbai",
    "description": "Choose the Best Ertiga on Rent Navi Mumbai for comfortable travel with clean vehicles, professional chauffeurs, and reliable rental services."
  },
  {
    "name": "Cheapest Ertiga Rental Navi Mumbai",
    "description": "Reserve Cheapest Ertiga Rental Navi Mumbai with affordable fares, spacious seating, experienced drivers, and quality travel services."
  },
  {
    "name": "Ertiga on Rent with Driver Navi Mumbai",
    "description": "Book Ertiga on Rent with Driver Navi Mumbai for hassle-free travel with trained chauffeurs, comfortable seating, and smooth transportation."
  },
  {
    "name": "Ertiga Rental Service Navi Mumbai",
    "description": "Choose Ertiga Rental Service Navi Mumbai for family trips, airport transfers, corporate travel, and outstation journeys with reliable chauffeur-driven vehicles."
  },
  {
    "name": "Ertiga Airport Pickup Navi Mumbai",
    "description": "Reserve Ertiga Airport Pickup Navi Mumbai for timely airport arrivals with luggage assistance, professional drivers, and comfortable AC vehicles."
  },
  {
    "name": "Ertiga Airport Drop Navi Mumbai",
    "description": "Book Ertiga Airport Drop Navi Mumbai for punctual airport transfers with clean vehicles, experienced chauffeurs, and convenient travel solutions."
  },
  {
    "name": "Ertiga Outstation Rental Navi Mumbai",
    "description": "Choose Ertiga Outstation Rental Navi Mumbai for one-way and round-trip travel with affordable pricing, spacious interiors, and reliable drivers."
  },
  {
    "name": "Ertiga Cab for Outstation Navi Mumbai",
    "description": "Book Ertiga Cab for Outstation Navi Mumbai for long-distance journeys with comfortable seating, extra luggage space, and professional chauffeur service."
  },
  {
    "name": "24x7 Ertiga on Rent in Navi Mumbai",
    "description": "Reserve 24x7 Ertiga on Rent in Navi Mumbai for round-the-clock transportation with reliable drivers and comfortable AC vehicles."
  },
  {
    "name": "Late Night Ertiga Rental Navi Mumbai",
    "description": "Book Late Night Ertiga Rental Navi Mumbai for safe and convenient travel with professional chauffeurs available during late hours."
  },
  {
    "name": "Ertiga on Rent in Mumbai",
    "description": "Choose Ertiga on Rent in Mumbai for family travel, airport transfers, corporate trips, and outstation journeys with premium chauffeur-driven service."
  },
  {
    "name": "Ertiga Car on Rent in Mumbai",
    "description": "Reserve Ertiga Car on Rent in Mumbai for affordable group transportation with spacious seating, AC comfort, and experienced drivers."
  },
  {
    "name": "Ertiga CNG on Rent in Mumbai",
    "description": "Book Ertiga CNG on Rent in Mumbai for economical travel with fuel-efficient performance, comfortable seating, and reliable rental service."
  },
  {
    "name": "Ertiga on Hire in Mumbai",
    "description": "Choose Ertiga on Hire in Mumbai for flexible rental options with professional chauffeurs, clean vehicles, and comfortable travel."
  },
  {
    "name": "Ertiga Rent per KM in Mumbai",
    "description": "Get Ertiga Rent per KM in Mumbai with transparent pricing, affordable kilometer-based rental packages, and reliable chauffeur-driven transportation."
  }
],
"tableData": [
  ["Ertiga on Rent in Navi Mumbai", "Ertiga Rental Navi Mumbai"],
  ["Ertiga Hire in Navi Mumbai", "Ertiga Car Rental Navi Mumbai"],
  ["Ertiga Taxi Service Navi Mumbai", "Book Ertiga on Rent in Navi Mumbai"],
  ["Best Ertiga on Rent Navi Mumbai", "Cheapest Ertiga Rental Navi Mumbai"],
  ["Ertiga on Rent with Driver Navi Mumbai", "Ertiga Rental Service Navi Mumbai"],
  ["Ertiga Airport Pickup Navi Mumbai", "Ertiga Airport Drop Navi Mumbai"],
  ["Ertiga Outstation Rental Navi Mumbai", "Ertiga Cab for Outstation Navi Mumbai"],
  ["24x7 Ertiga on Rent in Navi Mumbai", "Late Night Ertiga Rental Navi Mumbai"],
  ["Ertiga on Rent in Mumbai", "Ertiga Car on Rent in Mumbai"],
  ["Ertiga CNG on Rent in Mumbai", "Ertiga on Hire in Mumbai"],
  ["Ertiga Rent per KM in Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Ertiga on Rent in Navi Mumbai",
    WhyChoosedescription: "Shreesha Travels provides Maruti Ertiga on rent in Navi Mumbai for family trips, airport transfers, corporate travel, local rides, weddings, and outstation journeys. Enjoy spacious seating, comfortable interiors, and reliable chauffeur-driven service."
  },
  {
    WhyChooseheading: "Spacious Vehicle for Family & Group Travel",
    WhyChoosedescription: "The Maruti Ertiga is an ideal choice for families and small groups with comfortable seating, good luggage capacity, and a smooth driving experience for both city and long-distance travel."
  },
  {
    WhyChooseheading: "Available for Local & Outstation Trips",
    WhyChoosedescription: "Hire an Ertiga for Navi Mumbai city travel, airport pickups and drops, one-way transfers, round trips, weekend getaways, pilgrimage tours, and outstation destinations across Maharashtra and India."
  },
  {
    WhyChooseheading: "Affordable Rental Packages",
    WhyChoosedescription: "Choose from hourly rentals, full-day packages, airport transfer bookings, one-way cabs, round-trip options, and customized rental plans according to your travel needs."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Safe Journeys",
    WhyChoosedescription: "Our experienced drivers are familiar with Navi Mumbai, Mumbai routes, highways, and popular destinations, ensuring safe driving, timely service, and a comfortable travel experience."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Ertiga Cars",
    WhyChoosedescription: "Every Ertiga is regularly serviced, air-conditioned, sanitized, and checked before every trip to provide passengers with a clean, safe, and enjoyable journey."
  },
  {
    WhyChooseheading: "Perfect for Airport, Corporate & Family Travel",
    WhyChoosedescription: "Our Ertiga rental service is suitable for airport transfers, business meetings, hotel transportation, family vacations, wedding guests, sightseeing tours, and group outings."
  },
  {
    WhyChooseheading: "Book Ertiga on Rent in Navi Mumbai with Shreesha Travels",
    WhyChoosedescription: "Get affordable rental plans, quick booking support, professional chauffeur service, and comfortable Maruti Ertiga rentals for every local and outstation travel requirement."
  }
]

};

const faqData = [
  {
    question: "Can I rent an Ertiga in Navi Mumbai for local travel?",
    answer: "Yes, Ertiga is available for local travel, sightseeing, business meetings, airport transfers, and full-day rental requirements."
  },
  {
    question: "Is Ertiga available for outstation travel from Navi Mumbai?",
    answer: "Yes, you can book Ertiga for one-way, round-trip, and multi-day outstation journeys across Maharashtra and other states."
  },
  {
    question: "How many passengers can travel in an Ertiga?",
    answer: "Maruti Ertiga is suitable for families and small groups looking for comfortable seating with sufficient luggage space."
  },
  {
    question: "Do you provide Ertiga for airport pickup and drop?",
    answer: "Yes, Ertiga rental is available for Mumbai Airport and Navi Mumbai Airport transfers."
  },
  {
    question: "Can I hire Ertiga for corporate travel?",
    answer: "Yes, our Ertiga rental service is suitable for employee transportation, business meetings, client visits, and official travel."
  },
  {
    question: "Are chauffeur services included with Ertiga rental?",
    answer: "Yes, every Ertiga booking includes a professional driver for safe and comfortable travel."
  },
  {
    question: "Can I book Ertiga for weddings and family functions?",
    answer: "Yes, Ertiga is available for wedding guests, family events, hotel transfers, and special occasions."
  },
  {
    question: "How is the Ertiga rental fare calculated?",
    answer: "The fare depends on travel distance, rental duration, trip type, selected package, tolls, parking charges, and additional requirements."
  },
  {
    question: "Can I rent an Ertiga for multiple days?",
    answer: "Yes, multi-day rental packages are available for holidays, business tours, pilgrimage trips, and customized travel plans."
  },
  {
    question: "How can I book Ertiga on Rent in Navi Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, travel date, destination, passenger count, and rental requirement to receive a customized quotation and confirmed booking."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Deshmukh",
    feedback: "We rented an Ertiga for our family trip from Navi Mumbai. The vehicle was spacious, clean, and the driver provided excellent service throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Shah",
    feedback: "Great Ertiga rental experience. The booking process was easy, the car was comfortable, and the chauffeur was polite and punctual.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Navi Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/ertiga-on-rent-in-navi-mumbai.webp",
  "description":
    "Book Ertiga On Rent in Navi Mumbai with Shreesha Tours & Travels for comfortable and reliable taxi services. We provide Maruti Ertiga cabs with experienced drivers for local travel, airport pickup and drop, outstation trips, family vacations, corporate travel, sightseeing tours, and long-distance journeys with 24x7 booking.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/ertiga-on-rent-in-navi-mumbai"
  }
};









    return (
        <div>
<Helmet>
  <title>Ertiga On Rent in Navi Mumbai | Ertiga Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Ertiga On Rent in Navi Mumbai with Shreesha Travels for safe and comfortable taxi services. Hire Maruti Ertiga with experienced drivers for local travel, airport pickup, airport drop, outstation trips, family tours, corporate travel, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Ertiga On Rent in Navi Mumbai, Ertiga Rental Navi Mumbai, Ertiga Hire in Navi Mumbai, Ertiga Car Rental Navi Mumbai, Ertiga Taxi Service Navi Mumbai, Book Ertiga On Rent in Navi Mumbai, Best Ertiga On Rent Navi Mumbai, Cheapest Ertiga Rental Navi Mumbai, Ertiga On Rent with Driver Navi Mumbai, Ertiga Rental Service Navi Mumbai, Ertiga Airport Pickup Navi Mumbai, Ertiga Airport Taxi Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ertigaonrentinnavimumbai;